/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useCallback } from 'react';
import Pagination from '../../components/Pagination';
import 'tw-elements';
import { useLocation, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../components/Shimmer/itemShimmer';
import SearchEmptyScreen from '../../components/SearchEmptyScreen';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationPrompt from '../../components/ConfirmationPrompt';
import AnimatedModel from '../../components/Animation/AnimatedModel';
import { dataService } from '../../services/data.services';
import GlobalContext from '../../components/Context/GloablContext';
import Table from './components/Table';
import TopBarWithShadow from '../../components/TopBar/TopBarWithShadow';
import { Staff } from './StaffSlice';
import EmptyAddScreen from '../../components/EmptyAddScreen';
import { CognitoData } from '../../CommonMethods/CognitoData';
import CardHeader from '../../components/CardHeader';
import Debounce from '../../CommonMethods/Debounce';
import { tr } from '@faker-js/faker';
import { GetBranchId } from '../../CommonMethods/GetBranchId';

const ManageStaff = () => {
    const { setToastErrorMessage, setToastmessage} = useContext(GlobalContext);
    const dispatch = useDispatch();
    const StaffList = useSelector(state => state.StaffSlice);
    const { List} = StaffList;
    const [loading, setLoading] = useState(true);
    const [loadingActivation, setLoadingActivation] = useState(false);
    const location = useLocation();
    const [confirmationState, setConfirmationState] = useState({});
    const [searchParams, setSearchParams] = useSearchParams({page_number: 1});
    const [email, setemail] = useState('')
    const [fistLoading, setFirstLoading] = useState(false)
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const [placeholderIndex, setPlaceholderIndex] = useState(0);
    const placeholderOptions = [
        'Employee Number',
        'Full Name',
        'Email Address',
        'Mobile Number'
    ];
    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        // setLoading(true);
        setSearchParams({ page_number:  1 })
    }

    /* The below code is using the `useEffect` hook in React to set up an interval that changes the
    placeholder index cyclically every 2 seconds. The `setPlaceholderIndex` function is used to update
    the state of the placeholder index based on the previous index value and the length of the
    `placeholderOptions` array. The interval is cleared when the component unmounts to prevent memory
    leaks. */
    useEffect(() => {
        const interval = setInterval(() => {
            // Change placeholder index cyclically
            setPlaceholderIndex(prevIndex => (prevIndex + 1) % placeholderOptions.length);
        }, 2000);

        return () => clearInterval(interval);
    }, []);

    /* `const getBranch` is a function that is defined using the `useCallback` hook. It is used
    to fetch the list of admin users from the server and update the state with the response data.
    The function uses the `dispatch` function from the `useDispatch` hook to dispatch an action
    creator called `AdminUser` with the `searchParams` as an argument. The `AdminUser` action
    creator is responsible for making an API call to fetch the list of admin users from the server.
    Once the API call is successful, the function checks if the `success_status` property of the
    response data is true. If it is true, the function does nothing. If it is false, the function
    sets an error message using the `setToastErrorMessage` function. The `getBranch` function
    is memoized using the `useCallback` hook with the `location` value as a dependency, which means
    that it will only be redefined if the `location` value changes. */
    const getBranch = useCallback(async () => {
        try {
            setLoading(true)
            const user = await CognitoData();
            let branch_id = ""
            if(user.idToken.payload["custom:user_type"] === "institution-user" || user.idToken.payload["custom:user_type"] === "institution-admin") {
                branch_id = JSON.parse(localStorage.getItem('branch_details')).id
            } else {
                branch_id = user.idToken.payload["custom:branch_id"]
            }
            dispatch(Staff(`users?institution_id=${user.idToken.payload["custom:institution_id"]}&user_type=staff-user&branch_id=${branch_id}&${(searchParams.toString())}`)).then((response) => {
                if (response?.payload?.data.status===200) {
                    if(response.payload.data.data.data?.length === 0 && searchParams.get('search')===null && response?.payload?.data?.data.total_count === 0) {
                        setFirstLoading(true);
                    } else {
                        setEmptyScreenMessage("No matching records found.")  
                    }
                    if(Math.ceil(response?.payload?.data?.data.total_count / 10) <  Number(searchParams.get('page_number'))) {
                        if(response?.payload?.data?.data.total_count !== 0) {
                            // setToastErrorMessage('Something went wrong. Please try again')
                            setEmptyScreenMessage("No data found");
                        } else {
                            setEmptyScreenMessage("No matching records found.")
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    setEmptyScreenMessage("No data found");
                    // setToastErrorMessage('Something went wrong. Please try again')
                }
            })
            if(email===''){
                setemail(localStorage.getItem('email'))
            }
            // setsearchFieldDebounce(searchParams.get('search') !== null ? searchParams.get('search') : '')
        } catch (error) {
            handleLoadData()
            console.error(error);
            setToastErrorMessage(error?.response?.data?.message || "Something Went Wrong")
        }
    }, [location]);

    
    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        // setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value) => {
        // setLoading(true);
        // setEmptyScreenMessage("We couldn't find anything that matched your search")
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    /* `useEffect(() => { getBranch(); }, [getBranch]);` is a hook that is used to run
    the `getBranch` function whenever the `getBranch` function changes. In this case,
    the `getBranch` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getBranch` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response
    data. */
    useEffect(() => {
        // if(!searchParams.get('sort')) {
        //     handleSearchParams('sort', `created_at+desc`)
        // }
        getBranch();
    }, [searchParams]);

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setConfirmationState({});

    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        setLoadingActivation(true);
        try {
            let body = { }
            if(confirmationState.status !== "Reset Password") {
                body = {
                    "status": confirmationState.status === 'Activate' ? true : false             
                }
            }
            let endpoint= confirmationState.status==="Reset Password"?`admin-users/reset-password/${confirmationState.item.email_address}`:`admin-users/update/${confirmationState.item.email_address}`
            if(confirmationState.status==="Reset Password"){
                body={
                    reset:true
                }
            }
            const response = await dataService.PatchAPI(body,endpoint);
            setLoadingActivation(false);
            if (response.data.success_status) {
                setToastmessage(response.data.message) 
                getBranch();
            } else {
                setToastErrorMessage(response.data.message);
                getBranch()
            }
            handleConformationClick();
            // setLoading(true)
        } catch (error) {
            handleConformationClick();
            setLoadingActivation(false);
            setToastErrorMessage(error?.response?.data?.message || "Something Went Wrong")
        }
    }

    const [searchValue, setSearchValue] = useState("")
 
    /* The above code is using the `useCallback` hook in React to create a memoized version of the
    `Debounce` function. The `Debounce` function is a utility function that delays the execution of
    a given function until a certain amount of time has passed without any further calls to the
    function. */
    const optimizedFn = useCallback(
        Debounce((value) => handleSearchParams('search', value)),
        []
    );
    /**
     * The handleSearchValue function updates the search value and calls an optimized function with the
     * new value.
     */
    const handleSearchValue = (key, value) => {
        setSearchValue(value)
        optimizedFn(value)
    }

    useEffect(()=>{
        if(searchParams.get('search') !== null) setSearchValue(searchParams.get('search'))
    },searchParams)

    return (
        <>
            <CardHeader noPadding>                         
                <TopBarWithShadow
                    AddButton={true}
                    SearchInput={true}
                    Tittle={'Employee Directory'}
                    AddButtonName={'Add Employee'}
                    SearchValue={searchValue}
                    handleOnClickSearch={handleSearchValue}
                    isClick={"/employee-master/manage-employee/add-employee"}
                    customSearchPlaceHolder={placeholderOptions[placeholderIndex]}
                />
                <CardHeader body >
                    {loading ? <ItemShimmer /> :
                        (
                            <>
                                <Table
                                    pageNumber={Number(searchParams.get('page_number')) || 1}
                                    handleOnClickSort={handleSearchParams}
                                    sortValue={searchParams.get('sort') || ''}
                                    setConfirmationState={setConfirmationState}
                                    email={email}
                                    setLoading={setLoading}
                                    getBranch={getBranch}
                                    searchParams={searchParams}
                                />
                                {(List.total_count > 10) && <Pagination
                                    totalPageNumber={Math.ceil(List.total_count / 10)}
                                    TotalCount={List.total_count}
                                    selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                />}
                            </>
                        )
                    }
                </CardHeader>
            </CardHeader>
            {Object.keys(confirmationState)?.length > 0 && confirmationState?.status  && 
            <AnimatedModel 
                Children={
                    <ConfirmationPrompt 
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`${confirmationState.status==='Reset Password'?'Reset Password':`${confirmationState.status} User`} `}
                        message = {`Are you sure you want to ${confirmationState.status === 'Reset Password' ? `${confirmationState.status} for` : confirmationState.status} this user ?`}
                        buttonName = {confirmationState.status}
                        loadingActivation={loadingActivation}
                    />
                }
            />  
            }
        </>
    );
}

export default ManageStaff;
